import moment from "moment";
import React, { useEffect, useState } from "react";
import styles from './Calendar.module.scss';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";

export default function CalendarTimesRow({
    zoom,
    backgroundColor,
    selectedChannel,
    hoursBeforeDay,
    hoursAfterDay,
    onZoomChange,

}: {
    zoom: number[]
    selectedChannel: string
    hoursBeforeDay: number
    hoursAfterDay: number
    backgroundColor?: string;
    onZoomChange: (val: number[]) => void
}) {

    const dispatch = useAppDispatch()

    const [times, setTimes] = useState([])
    // const hoursBeforeDay = useAppSelector(selectHoursBeforeDay)
    // const hoursAfterDay = useAppSelector(selectHoursAfterDay)
    // const selectedChannel = useAppSelector(selectSelectedChannel)

    useEffect(() => {
        let ttimes = []
        for (let i = -1 * (selectedChannel && selectedChannel !== "ACTIVE" ? 0 : hoursBeforeDay); i < 24 + (selectedChannel && selectedChannel !== "ACTIVE" ? 0 : hoursAfterDay); i++) {
            ttimes.push(moment.utc(i * 1000 * 60 * 60).format('HH'))
        }
        setTimes(ttimes)
    }, [selectedChannel, hoursBeforeDay, hoursAfterDay])

    const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
        let delta = Math.abs(event.deltaY) / 200
        if (event.deltaY > 0 && zoom[1] < 100) {
            onZoomChange([zoom[0] + delta, zoom[1] + delta])
        } else if (zoom[0] > 0) {
            onZoomChange([zoom[0] - delta, zoom[1] - delta])
        }
    };

    return (
        <div className={styles.tableDiv + " " + styles.header} onWheel={handleWheel}>
            <table width="100%" style={{ height: 45 }}>
                <thead style={{ backgroundColor }}>
                    {times.map((time, i) => <td key={i} style={{ width: `${100 / (24 + (selectedChannel && selectedChannel !== "ACTIVE" ? 0 : (hoursBeforeDay + hoursAfterDay)))}%` }}>
                        <div style={{ fontSize: 12, marginLeft: -7, width: 20 }}>{time}</div>
                    </td>)}
                </thead>
            </table>
        </div>
    )
}



